import { IdleInterruptSourceEventTarget, IdleInterruptSourceEventTargetOptions } from './interrupt-source-event-target';
import { getWindow } from 'ssr-window';

/**
 * An interrupt source on the Window object.
 */
export class IdleInterruptSourceWindow extends IdleInterruptSourceEventTarget {
    constructor(events: string, options?: number | IdleInterruptSourceEventTargetOptions) {
        const window = getWindow();

        super(() => window, events, options);
    }
}
